<template>
  <div>
    <v-tabs
      v-model="tab"
      dark
      class="rounded-lg"
      dense
      background-color="primary"
      active-class="tab-active"
      slider-color="#ffbc00"
    >
      <v-tab class="font-weight-black">Niveles</v-tab>
      <v-tab class="font-weight-black">Grados</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" touchless>
      <v-tab-item>
        <niveles class="mt-2" @getAllGradosNiveles="getAllGrados"></niveles>
      </v-tab-item>
      <v-tab-item>
        <grados
          class="mt-2"
          :Grados="getGrados"
          @getGradosPaises="getAllGradosPais"
        ></grados>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import axios from "../../../helpers/axios";
import { mapMutations } from "vuex";

import Niveles from "@/views/Manager/NivelesyGrados/components/Niveles.vue";
import Grados from "@/views/Manager/NivelesyGrados/components/Grados.vue";

export default {
  name: "nivelesGrados",

  components: {
    niveles: Niveles,
    grados: Grados,
  },

  data: () => ({
    grados: [],
    getGrados: [],
    tab: 0,
  }),

  mounted() {
    this.getAllGrados();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    /////////////////////////////////////////
    async getAllGrados() {
      try {
        let response = await axios.get("/manager/gradoCkOne/");
        this.getGrados = response.data;
        console.log(this.getGrado);
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Error Interno al Registrar los Campos",
          tiempo: null,
        });
      }
    },
    ////////////////////////////////////////

    //////// consultar grados por pais //////////
    async getAllGradosPais(id) {
      try {
        const response = await axios.get(
          "/manager/gradoCkOne/getGradoPais/" + id
        );
        this.getGrados = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
  },
};
</script>
